import { Author } from '@/lib/types';
import Link from 'next/link';

interface AuthorHeaderProps {
  author: Author;
}

export default function AuthorHeader({ author }: AuthorHeaderProps) {
  return (
    <div className="bg-[#F5F4F0] border-b border-[#D4D4D4] py-12 px-5">
      <div className="max-w-[900px] mx-auto grid grid-cols-1 md:grid-cols-[160px_1fr] gap-9 items-start">
        {/* Avatar */}
        <div
          className={`w-40 h-40 circle-avatar ${author.avatarBg} flex items-center justify-center mx-auto md:mx-0`}
        >
          <span className="font-['Playfair_Display',Georgia,serif] font-bold text-[48px] text-[#6B6B6B] leading-none">
            {author.initials}
          </span>
        </div>

        {/* Info */}
        <div>
          <h1 className="font-['Playfair_Display',Georgia,serif] font-bold text-[38px] leading-[1.15] mb-1.5 text-[#0D0D0D]">
            {author.name}
          </h1>
          <p className="font-['IBM_Plex_Sans',system-ui,sans-serif] font-semibold text-[15px] text-[#C8102E] mb-1">
            {author.role}
          </p>
          <p className="font-['IBM_Plex_Sans',system-ui,sans-serif] text-[13px] text-[#6B6B6B] mb-4">
            {author.beat}
          </p>
          <p className="font-['Source_Serif_4',Georgia,serif] text-[15px] leading-[1.65] text-[#2D2D2D] max-w-[540px] mb-5">
            {author.bio}
          </p>
          <div className="flex gap-3 flex-wrap mb-3">
            {['Email', 'X / Twitter', 'LinkedIn'].map((platform) => (
              <button
                key={platform}
                className="border border-[#D4D4D4] px-3.5 py-1.5 font-['IBM_Plex_Sans',system-ui,sans-serif] text-[12px] text-[#2D2D2D] hover:bg-[#1A1A1A] hover:text-white hover:border-[#1A1A1A] transition-all cursor-pointer"
              >
                {platform}
              </button>
            ))}
          </div>
          <p className="font-['IBM_Plex_Sans',system-ui,sans-serif] text-[12px] text-[#9A9A9A]">
            {author.articleCount} articles · {author.yearsAtVeritas} years at Veritas
          </p>
        </div>
      </div>
    </div>
  );
}
